type Props = {
  /** Written by the platform team for the store owner (may be empty). */
  reason?: string | null
}

/** Shown to the store owner and team while the platform team has suspended the store. They can still sign in. */
export function StoreSuspendedBanner({ reason }: Props) {
  const why = reason?.trim()
  return (
    <div
      className="border-b border-destructive/30 bg-destructive/10 px-4 py-3 text-foreground sm:px-6 lg:px-8"
      role="alert"
    >
      <div className="mx-auto max-w-7xl space-y-0.5">
        <p className="text-sm font-semibold text-destructive">Your store is suspended</p>
        <p className="text-xs leading-relaxed text-muted-foreground">
          Shoppers currently see “This store is temporarily unavailable”: they can’t browse, sign in or order. You can keep
          working in your admin. Contact Kartly support to have your store reactivated.
        </p>
        {why ? (
          <p className="text-xs leading-relaxed">
            <span className="font-medium">Reason from Kartly:</span> {why}
          </p>
        ) : null}
      </div>
    </div>
  )
}
